<template>
    <svg width="16" height="23" viewBox="0 0 16 23" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
        <rect x="2.50195" y="11.5586" width="10.5602" height="10.5602" rx="0.754297" fill="currentColor" />
        <ellipse cx="7.65723" cy="5.78294" rx="5.65723" ry="5.78294" fill="currentColor" />
    </svg>
</template>
